// services/purchases/DebitNotePurchaseService.ts
import { debitNotePurchaseApi } from '../../api';
import { DebitNoteProduct } from '../../types/purchases/DebitNotePurchase';


const DebitNoteService = {
  /**
   * Agregar un producto a una nota de débito
   * POST /api/debit-note-purchases/products
   */
  addProduct: async (product: DebitNoteProduct) => {
    const response = await debitNotePurchaseApi.addCustom('/products', product);
    return response.data;
  },

  /**
   * Eliminar un producto de una nota de débito
   * DELETE /api/debit-note-purchases/products/{detailId}
   */
  deleteProduct: async (detailId: number) => {
    const response = await debitNotePurchaseApi.removeCustom(`/products/${detailId}`);
    return response.data;
  },

};

export default DebitNoteService;
